import deletePayments from 'modules/Payments/services/deletePayments';

export const useDeletePayments = () => {
  return ({ ids, excludeIds }: { ids: string[]; excludeIds: boolean }) => {
    return deletePayments({ filters: { ids }, excludeIds });
  };
};
